module.exports = __webpack_public_path__ + "img/ic_topic_products.8f05d0fc.svg";